/**
 * @generated SignedSource<<f5e8f6db16fcaef7aa0ab86c6953521a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterPrice_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuPriceRanges_user">;
  readonly " $fragmentType": "SbMobileRefineMenuFilterPrice_user";
};
export type SbMobileRefineMenuFilterPrice_user$key = {
  readonly " $data"?: SbMobileRefineMenuFilterPrice_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbMobileRefineMenuFilterPrice_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterPrice_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "77f01d41e43e052c219d3b8138861868";

export default node;
